import {UyapRequest} from "./UyapRequest";
import app from "@/main";
import {ISorguSonuc} from "./CommonInterfaces";

export interface BagkurEmekliTalep {
    dosyaId: string,
    kisiKurumId: number,
}

export interface BagkurEmekliCevap extends ISorguSonuc<IBagkurEmekliSonuc>{}

export interface IBagkurEmekliSonuc {
    emekliKaydi4b: IEmekliKaydi4B,   // DEV-3354: UYAP "emekliKaydi4B" -> "emekliKaydi4b"
    hataKodu: 0 | 995 | number,      // başarılı | kayıt bulunamadı
    hataMesaji: string
}

export interface IEmekliKaydi4B {
    aylikGoruntuleForm?: Array<IAylikGoruntuleForm>,
    sonucKod: number,
    sonucMesaj: string
}

// DEV-3354: aylık satırlarında alt çizgili adlar kalktı
// (brut_aylik -> brutAylik, ekOdeme_Tutari -> ekOdemeTutari, ...).
export interface IAylikGoruntuleForm {
    adi: string,
    aylikBaslangicTarihi: string,
    aylikNevi: string,
    bankaAdi: string,
    brutAylik: string,
    dogumTarihi: string,
    durumKodu: number,
    durumKoduString: string,
    ekOdemeTutari: string,
    makamTazminatiTutari: string,
    odemeDonemi: string,
    onayDurumu: number,
    onayDurumuString: string,
    saglikKesintiTutari: string,
    sgmAdi: string,
    sicilNo: string,
    soyAdi: string,
    subeAdi: string,
    tahsisDosyaNo: number,
    tahsisIlAdi: string,
    talepTarihi: string,
    tcKimlikNo: string,
    toplam: string,
    yakinlik: string,
    yurtDisi: string
}

// Güncellenme Tarihi: 21/01/2026

export default class BagkurEmekli extends UyapRequest<BagkurEmekliTalep, BagkurEmekliCevap> {
    getMethod(): 'GET' | 'POST' {
        return 'POST';
    }

    getSpinnerMessage(){
        return "Bağkur emekli bilgileri sorgulanıyor...";
    }


    cache() {
        return {
            active: true,
            ttl: (60 * 24), //* 1 gun
            key: "BagkurEmekli_" + app.$uyapHelper.hash(this.talepData)
        };
    }

    getMockResponse(): any {
        return {"borcluBilgileri":{"kisiTumDVO":{"olumKaydi":false,"isAvukat":false,"isGecerlilikAktifAvukat":false,"isNoter":false,"isTarafUyari":false,"isHakimSavci":false,"mernisDegisiklikVarmi":false,"mernisDegisiklikNedeni":"","yabanci":false,"mavikart":false,"sorguTuru":0,"tcKimlikNo":"4********10","adi":"AH**** MÜ***","soyadi":"YA*******","babaAdi":"A*********","anaAdi":"Ş*****","dogumTarihiStr":"1957","aktifMernisAdresiSorgusu":true,"hasOlumKaydi":false},"kisiKurumId":28698317,"turu":0},"sorgulayanBilgileri":"Av.NİHAN ERDOĞAN","portalTuru":2,"dosyaOzetDVO":{"birimDVO":{"birimAdi":"Ankara 2. Genel İcra Dairesi","birimId":"1000963","orgKodu":"1.04.011.000.6037","duzey1":"1","duzey2":"04","duzey3":"011","duzey4":"000","duzey5":"6037","birimTuru1":"11","birimTuru2":"1101","birimTuru3":"1199","evraginBirimDVODaGonderilecegiBirimBilgisi":0,"yeniBirimEkle":true,"orgKoduDegisti":false,"isTumunuKopyala":false,"eskiAd":"","eskiOrgKod":"","taranmamisKaydetme":"","testMi":0},"rolIdList":[],"isBirimKapali":false,"dosyaTurKod":35,"dosyaTurAd":"İcra Dosyası","dosyaNo":"2023/27440","dosyaNoYil":2023,"dosyaSira":27440,"dosyaId":"013@RlwAzAkR3QHUdOJ2IlEfPyXQ@GvneCEN0e5cwJawkq6eNI2QN1fKALitwUg+","dosyaAcilisTarihi":"08/07/2023 10:35","genelDosyaDurumu":"Açık","genelDosyaDurumuAsInteger":0,"taraflar":"ABDULSELAM DENİZ, AHMETİ MÜNÜR YALÇINALP","vekilId":0,"vekilMi":false,"vekilHazineAvukatiMi":false},"sorguTarihi":"21/01/2026 11:45","sorguSonucDVO":{"emekliKaydi4b":{"aylikGoruntuleForm":[{"adi":"AHMETİ MÜNÜR","aylikBaslangicTarihi":"01/09/2019","aylikNevi":"Yaşlılık Aylığı","bankaAdi":"İŞ BANKASI                                        ","brutAylik":"16.231,73","dogumTarihi":"25/08/1957","durumKodu":1,"durumKoduString":"Birinci Karar Yapıldı","ekOdemeTutari":"649,27","makamTazminatiTutari":"0.00","odemeDonemi":"27/01/2026","onayDurumu":6,"onayDurumuString":"Ödeme durumda ","saglikKesintiTutari":"0.00","sgmAdi":"RÜZGARLI SOSYAL GÜVENLİK MERKEZİ","sicilNo":"1173483581     ","soyAdi":"YALÇINALP","subeAdi":"DEMETEVLER ŞB.","tahsisDosyaNo":2948354,"tahsisIlAdi":"6","talepTarihi":"26/08/2019","tcKimlikNo":"47161224210","toplam":"16.881,00","yakinlik":"Kendisi","yurtDisi":"Hayır"}],"sonucKod":0,"sonucMesaj":""},"hataKodu":0,"hataMesaji":""},"sorgulamaTuru":"Bağkur Emeklisi","sorguSonucu":true,"hasError":false,"hasData":false,"isMock":false};
    }

    getUrl(): string {
        return this.ImzaClientAddr + 'borclu_bilgileri_goruntule_sgk_bagkurEmekliBilgileri.ajx';
    }

    async parse(data: any): Promise<BagkurEmekliCevap> {
        // DEV-3354 (DEV-2233 kalıbı): kayıt yoksa sorguSonucDVO hiç dönmüyor,
        // kimlik bilgisi eksikse düz hata metni geliyor.
        const sonuc = data.sorguSonucDVO;
        if (typeof sonuc === "string" && sonuc) {
            data.message = sonuc;
            data.sorguSonucu = false;
        } else if (!sonuc || sonuc.hataKodu != 0) {
            data.message = sonuc?.hataMesaji || "Kayıt bulunamadı";
            data.sorguSonucu = false;
        } else
            data.message = "Sorgulama başarılı";
        return data;
    }

}